import { Directive, ElementRef, HostListener, inject, Renderer2 } from '@angular/core';

@Directive({
	selector: '[sklCopyOnly]'
})
export class CopyOnlyDirective {
	private el = inject(ElementRef);
	private renderer = inject(Renderer2);

	public ngAfterViewInit(): void {
		const nativeEl = this.el.nativeElement;

		this.renderer.setStyle(nativeEl, 'caret-color', 'transparent');
		this.renderer.setStyle(nativeEl, 'cursor', 'default');
		this.renderer.setStyle(nativeEl, 'outline', 'none');
	}

	@HostListener('paste', ['$event'])
	public onPaste(event: ClipboardEvent): void {
		event.preventDefault();
	}

	@HostListener('keydown', ['$event'])
	public onKeyDown(event: KeyboardEvent): void {
		const allowedKeys = [
			'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
			'Tab', 'Home', 'End', 'Shift', 'Control', 'Meta',
			'F5'
		];

		if ((event.ctrlKey || event.metaKey) && ['a', 'c'].includes(event.key.toLowerCase())) {
			return;
		}

		if (!allowedKeys.includes(event.key)) {
			event.preventDefault();
		}
	}
}
